<template>
  <div>
    <!----------------- Main contents Area --------------------->
    <!-- mt-3: margin top-3 -->
    <main class="mt-3">
      <div class="main p-2">
        <h2 class="text-center"><u>&nbsp;확정 수지계산서 리스트&nbsp;</u></h2>

        <div class="text-primary text-start fs-6 mb-2 print-hide">
          <b>[ &nbsp; 확정수지계산서 검색 &nbsp; ]</b>
        </div>
        <table class="table table-bordered border-success align-middle w-100 h-auto print-hide text-center">
          <tbody>
            <tr>
              <th class="table-secondary col-1">
                <select class="form-select form-select-sm" v-model="this.searchDuration">
                  <option value="G" selected>행사월</option>
                  <!-- <option value="E">정산월</option> -->
                </select>
              </th>
              <td class="col-2">
                <div class="input-group">
                  <span class="input-group-text input-group-sm" style="font-size:smaller">선택월</span>
                  <input type="month" class="form-control form-control-sm" ref="searchMonth" v-model="this.searchMonth" style="font-size:smaller">
                </div>
              </td>
              <th class="table-secondary col-1">
                담당자
              </th>
              <td class="col-2">
                <select class="form-select form-select-sm" v-model="this.chargePerson" style="font-size: smaller;" ref="dealChargeId" :disabled="!isChargeListOpen">
                  <option :value="p.handlerId" :key="i" v-for="(p,i) in this.chargePListForSearch">{{ p.handlerNameKor }}</option>
                </select>
              </td>
            </tr>
          </tbody> 
        </table>
        <div style="display: flex; justify-content: end;">
          <div class="text-success text-end fs-6 mb-2 print-hide">
            <b><button type="button" class="btn btn-outline-secondary btn-sm" @click="searchDefault">검색조건초기화</button></b>
            &nbsp;&nbsp;
            <b><button type="button" class="btn btn-outline-primary btn-sm" @click="searchSettleData">검색하기</button></b>
          </div>
        </div>

        <div style="display: flex; justify-content: start;">
          <div class="text-success text-end fs-6 mb-2 print-hide">
            <b><button type="button" class="btn btn-outline-success btn-sm" @click="exportToExcels">엑셀다운로드</button></b>
            <!-- &nbsp;&nbsp;
            <b><button type="button" class="btn btn-outline-warning btn-sm" @click="confirmAndPrint">자료인쇄</button></b> -->
          </div>
        </div>

        <!-- 모달영역 -->
        <div v-if="showModal" class="modal">
          <div class="modal-content">
            <span @click="showModal = false" class="close print-hide">&times;</span>
            <Modal_BusinessInvoice :showModal="showModal" :modalContent="this.sel_dealCode" @close="closeModal"/>
          </div>
        </div>

        <!-- 정산정보 조회결과 -->
        <div class="mt-3 print-hide" style="height: auto;">
          <ag-grid-vue3 
            style="width: 100%; height: 800px;" 
            class="ag-theme-balham" 
            :columnDefs="columnDefs"
            :rowData="rowData"
            :gridOptions="gridOptions"
            @grid-ready="onGridReady"
            @selection-changed="onSelectionChanged"
            @cell-clicked="onCellClicked"
            >
          </ag-grid-vue3>
        </div>

      </div>
    </main>
  </div>
</template>

<script>
import Modal_BusinessInvoice from "./Modal_BusinessInvoice.vue";
import { AgGridVue } from 'ag-grid-vue3';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import * as XLSX from 'xlsx-js-style';      //엑셀다운로드시 폰트스타일반영
// import { utils, writeFile } from "xlsx-js-style";
import moment from 'moment';

export default {
  components: {
    Modal_BusinessInvoice,
    'ag-grid-vue3': AgGridVue
  },  
  data() {
    return {
      //modal컨트롤
      showModal: false,
      modalContent: "",
      sel_dealCode: "",      //선택된 딜코드

      searchDuration: "G",   //검색기간기준
      searchMonth: "",       //검색월
      chargePerson: "",      //검색명 담당자명

      partnerInfo: [],       //검색용 거래처정보

      //담당자데이타
      chargePList: [],       //담당자리스트

      settleDataInfo: [],    //검색된 정산데이타

      //agGrid
      columnDefs: [
        { headerCheckboxSelection: true, checkboxSelection: true, resizable: true, width: 50 },
        { 
          headerName: '',     field: '',   sortable: true, resizable: false, width: 70,
          cellRenderer: (params) => {
            if (params.data.plFix) {
              return '<button type="button" class="btn btn-danger btn-sm justify-content-center" style="font-size: smaller">파기</button>';
            }
            return params.value;
          }
        },
        { headerName: 'CodeNo',     field: 'plCode',   sortable: true, resizable: true, width: 122 },
        { headerName: '기준월',     field: 'plMonth',   sortable: true, resizable: true, width: 80 },
        { headerName: '부서',   field: 'tName',     sortable: true, resizable: true, width: 110 },
        { headerName: '담당자',   field: 'handlerNameKor',     sortable: true, resizable: true, width: 110 },
        { headerName: '판매가(KWD)',     field: 'sales_KRW_tot',      sortable: true, resizable: true, width: 110,
          cellStyle: () => {
            return { color: 'red'}
          }
        },

        { headerName: '지출금액(KWD)',     field: 'dPrice_curKRW_sum_n_tot',      sortable: true, resizable: true, width: 110,
          cellStyle: () => {
            return { color: 'blue'}
          }
        },
        { headerName: '지출금액(JPY)',     field: 'dPrice_curJPY_sum_n_tot',      sortable: true, resizable: true, width: 110,
          cellStyle: () => {
            return { color: 'red'}
          }
        },
        { headerName: '지출금액(USD)',     field: 'dPrice_curUSD_sum_n_tot',      sortable: true, resizable: true, width: 110,
          cellStyle: () => {
            return { color: 'darkgrey'}
          }
        },
        { headerName: '지출금액(TWD)',     field: 'dPrice_curTWD_sum_n_tot',      sortable: true, resizable: true, width: 110,
          cellStyle: () => {
            return { color: 'green'}
          }
        },

        { headerName: '알선수수료',  field: 'searchersFee_n_tot',     sortable: true, resizable: true, width: 110 },
        { headerName: '공급가액',    field: 'providePrice_n_tot',     sortable: true, resizable: true, width: 110 },
        { headerName: '부가가치세',  field: 'vatPrice_n_tot',     sortable: true, resizable: true, width: 110 },
        { headerName: '미수금',      field: 'accountRecievalbe_n_tot',     sortable: true, resizable: true, width: 110 },
        { headerName: '상품판매수익', field: 'profit_n_tot',     sortable: true, resizable: true, width: 110,
        cellStyle: () => {
            return { color: 'green'}
          }
        },
        { headerName: '비고',        field: 'plRemarks',     sortable: true, resizable: true, width: 300 }, 
      ],
      rowData: [],                    //정산검색결과 초기값
      gridOptions: {
        rowSelection: "multiple"
        //onGridReady: 'onGridReady'
      },

      selectedPNLfixed: [],               //선택된 수지계산서 정보
    };
  },
  created() {
    //this.productId = this.$route.query.productId;
    this.user = this.$store.state.user;
    this.getHandlerList()

    const today_tmp = moment();
    let today1 = moment([today_tmp.year(), today_tmp.month(), today_tmp.date()]);
    this.today = today1.format("YYYY-MM-DD")    
  }, 
  computed: {
    user() {
      return this.$store.state.user;
    },
    isChargeListOpen() {
      return this.user && this.user.handlerGrade >= 0 && this.user.handlerGrade <= 3;
    },
    chargePListForSearch() {
      if (this.isChargeListOpen) {
        return this.chargePList;
      }
      return this.chargePList.filter(p => p.handlerId === this.user.handlerId);
    }
  },
  mounted() {
    if(document.referrer == "") {
      this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
      location.replace("/")
    }
    //권한없는 로그인 차단
    if(this.user.handlerGrade >= 20) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/'});
    }

    this.dealChargeId = this.user.handlerId
    
    // 검색조건 담당자 기본값 세팅: 권한 없는 사용자는 자동으로 본인 고정
    if(!this.isChargeListOpen) {
      this.chargePerson = this.user.handlerId;
    }
    ////document.getElementById("notice").style.display = "none";
    document.getElementById("user").style.display = "none";

    this.searchSettleData("default")     // chargePerson이 세팅된 이후 호출되어야 함
  },
  methods: {
    async exportToExcels() {
      const selectedRows = this.gridOptions.api.getSelectedNodes().map(node => node.data);
      if (!selectedRows.length) 
      {
        this.$swal.fire('', '선택된 서류가 없습니다.', 'info');
        return;
      }

      for (const row of selectedRows) 
      {
        const selectedRowDetails = await this.$api("/api/pNlReportDetails", { param: [row.plCode] });
        if (!selectedRowDetails.length) 
        {
          this.$swal.fire('', `선택된 수지계산서(${row.plCode})의 상세데이타가 없습니다.`, 'warning');
          continue;
        }

        let detailRowsHtml = "";
        selectedRowDetails.forEach((pl, i) => {
          detailRowsHtml += `
            <tr>
              <td>${i + 1}</td>
              <td>${this.getDateFormat(pl.plDate)}</td>
              <td>${pl.plName}</td>
              <td class="text-end">${this.getCurrencyFormat(pl.priceTot)}</td>
              <td class="text-end">${this.getCurrencyFormat(pl.dPrice_curKRW_sum)}</td>
              <td class="text-end">${this.getCurrencyFormat(pl.dPrice_curJPY_sum)}</td>
              <td class="text-end">${this.getCurrencyFormat(pl.dPrice_curUSD_sum)}</td>
              <td class="text-end">${this.getCurrencyFormat(pl.dPrice_curTWD_sum)}</td>
              <td class="text-end">${this.getCurrencyFormat(pl.searchersFee)}</td>
              <td class="text-end">${this.getCurrencyFormat(pl.providePrice)}</td>
              <td class="text-end">${this.getCurrencyFormat(pl.vatPrice)}</td>
              <td class="text-end">${this.getCurrencyFormat(pl.accountRecievalbe)}</td>
              <td class="text-end">${this.getCurrencyFormat(pl.profit)}</td>
            </tr>
          `;
        });

        let table = document.createElement("table");
        table.innerHTML = `
          <tr>
            <td colspan="13">${row.plMonth} 확정수지계산서</td>
          </tr>
          <tr>
            <td colspan="13">${this.today}</td>
          </tr>
          <tr>
            <td colspan="3"></td>
            <th>부서</th>
            <td colspan="2">${row.tName}</td>
            <th>담당자</th>
            <td colspan="2">${row.handlerNameKor}</td>
            <th>기준환율</th>
            <td colspan="3">
              [JPY: ${row.plExJPY} ] / [USD: ${row.plExUSD} ] / [TWD: ${row.plExTWD} ]
            </td>
          </tr>
          <tr>
            <td colspan="7"></td>
          </tr>
          <tr>
            <th>No</th>
            <th>기준일자</th>
            <th>행사명</th>
            <th>판매금액(KRW)</th>
            <th>지출금액(KRW)</th>
            <th>지출금액(JPY)</th>
            <th>지출금액(USD)</th>
            <th>지출금액(TWD)</th>
            <th>알선수수료(KRW)</th>
            <th>공급가액(KRW)</th>
            <th>부가세(KRW)</th>
            <th>미수금(KRW)</th>
            <th>상품판매수익(KRW)</th>
          </tr>
          <tbody>
            ${detailRowsHtml}
          </tbody>
          <tr>
            <th colspan="3">합계</th>
            <th>${this.getCurrencyFormat(row.sales_KRW_tot)}</th>
            <th>${this.getCurrencyFormat(row.dPrice_curKRW_sum_n_tot)}</th>
            <th>${this.getCurrencyFormat(row.dPrice_curJPY_sum_n_tot)}</th>
            <th>${this.getCurrencyFormat(row.dPrice_curUSD_sum_n_tot)}</th>
            <th>${this.getCurrencyFormat(row.dPrice_curTWD_sum_n_tot)}</th>
            <th>${this.getCurrencyFormat(row.searchersFee_n_tot)}</th>
            <th>${this.getCurrencyFormat(row.providePrice_n_tot)}</th>
            <th>${this.getCurrencyFormat(row.vatPrice_n_tot)}</th>
            <th>${this.getCurrencyFormat(row.accountRecievalbe_n_tot)}</th>
            <th>${this.getCurrencyFormat(row.profit_n_tot)}</th>
          </tr>
          <tr>
            <th colspan="11" rowspan="2"></th>
            <th>여행손실금</th>
            <th>${this.getCurrencyFormat(row.tripLoss_tot)}</th>
          </tr>
          <tr>
            <th>여행정산금</th>
            <th>${this.getCurrencyFormat(row.tripProfit_tot)}</th>
          </tr>
        `;

        document.body.appendChild(table);

        let sheet = XLSX.utils.table_to_sheet(table, {raw: true});

        // 1. 병합 (s: start, e: end/r: row, c: column)
        sheet['!merges'] = [
          {s: {r:0, c:0}, e: {r:0, c:12}},
          {s: {r:1, c:0}, e: {r:1, c:12}},
          {s: {r:2, c:2}, e: {r:2, c:2}},
          {s: {r:2, c:4}, e: {r:2, c:5}},
          {s: {r:2, c:7}, e: {r:2, c:8}},
          {s: {r:2, c:10}, e: {r:2, c:12}},
        ];

        // 2. 컬럼 폭 지정 (wpx: width in pixels)
        sheet['!cols'] = [
          {wpx: 30}, {wpx: 80}, {wpx: 200}, {wpx: 100}, {wpx: 100}, {wpx: 100}, {wpx: 100},
          {wpx: 100}, {wpx: 100}, {wpx: 100}, {wpx: 100}, {wpx: 100}, {wpx: 120}
        ];

        // 3. 스타일 지정
        // 제목
        sheet['A1'].s = {
          font: { name: "맑은 고딕", sz: 20, bold: true, color: {rgb: "232323"} },
          alignment: { horizontal: "center", vertical: "center" },
          // fill: { fgColor: { rgb: "E3F2FD" } }
        };

        // 출력일자
        sheet['A2'].s = {
          font: { name: "맑은 고딕", sz: 10, bold: false, color: {rgb: "616161"} },
          alignment: { horizontal: "right", vertical: "center" }
        };

        const boldStyle = {
          font: { name: "맑은 고딕", bold: true, sz: 10 },
          alignment: { horizontal: "center", vertical: "center" }
        };
        ["D3","G3","J3"].forEach(cell =>{
          if(sheet[cell]) sheet[cell].s = boldStyle;
        });

        // 헤더 행
        const headerStyle = {
          font: { name: "맑은 고딕", sz: 11, bold: true, color: { rgb: "232323" } },
          fill: { fgColor: { rgb: "E9ECEF" } },
          alignment: { horizontal: "center", vertical: "center" },
          border: {
            top: { style: "thin", color: { rgb: "90CAF9" } },
            bottom: { style: "thin", color: { rgb: "90CAF9" } },
            left: { style: "thin", color: { rgb: "90CAF9" } },
            right: { style: "thin", color: { rgb: "90CAF9" } }
          }
        };
        // 5번째 행(r=4)의 0~12번 셀에 반복 적용
        for (let c = 0; c < 13; c++) 
        {
          let cellAddr = XLSX.utils.encode_cell({c, r:4});
          if (sheet[cellAddr]) sheet[cellAddr].s = headerStyle;
        }

        // 상세 데이터 행 스타일(예시: 모든 금액 칸 오른쪽 정렬)
        // 상세 데이터는 5행부터 시작, selectedRowDetails.length 만큼 반복
        for (let r = 5; r < 5 + selectedRowDetails.length; r++) 
        {
          for (let c = 3; c <= 12; c++) 
          {
            let cellAddr = XLSX.utils.encode_cell({c, r});
            if (sheet[cellAddr]) 
            {
              sheet[cellAddr].s = {
                font: { name: "맑은 고딕", sz: 10 },
                alignment: { horizontal: "right", vertical: "center" },
                border: {
                  top: { style: "thin", color: { rgb: "BDBDBD" } },
                  bottom: { style: "thin", color: { rgb: "BDBDBD" } },
                  left: { style: "thin", color: { rgb: "BDBDBD" } },
                  right: { style: "thin", color: { rgb: "BDBDBD" } }
                }
              };
            }
          }
        }

        let detailCount = selectedRowDetails.length;

        const boldSumStyle = {
          font: { name: "맑은 고딕", bold: true, sz: 11 },
          alignment: { horizontal: "right", vertical: "center" }
        };
        const sumRow = 5 + detailCount; // 합계 row 인덱스

        // 합계 행의 전체(0~12) 컬럼 모두 bold 처리
        for (let c = 3; c < 13; c++) 
        {
          const cellAddr = XLSX.utils.encode_cell({c, r: sumRow});
          if (sheet[cellAddr]) sheet[cellAddr].s = boldSumStyle;
        }

        // '합계' 텍스트(병합된 0~2번 컬럼)는 따로 스타일 지정(가운데 정렬, 볼드)
        const mergedCellAddr = XLSX.utils.encode_cell({c: 0, r: sumRow});
        if (sheet[mergedCellAddr]) {
          sheet[mergedCellAddr].s = {
            font: { name: "맑은 고딕", bold: true, sz: 11 },
            alignment: { horizontal: "center", vertical: "center" }
          };
        }

        // // '합계' : 1번째 셀(3컬럼 병합) bold
        // sheet['A' + (5 + detailCount)].s = {
        //   font: { name: "맑은 고딕", bold: true, sz: 11 },
        //   alignment: { horizontal: "center", vertical: "center" }
        // };

        // '여행손실금', '여행정산금' 각 위치(실제 테이블 row, 컬럼 주소 맞춤)
        sheet['L' + (7 + detailCount)].s = {
          font: { name: "맑은 고딕", bold: true, sz: 11 },
          alignment: { horizontal: "center", vertical: "center" }
        };
        sheet['L' + (8 + detailCount)].s = {
          font: { name: "맑은 고딕", bold: true, sz: 11 },
          alignment: { horizontal: "center", vertical: "center" }
        };

        // 필요시 추가 row와 셀마다 스타일 적용 반복

        let fileName = `${row.plCode}-${row.plMonth}_${row.handlerNameKor}`;
        let wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, sheet, "Sheet1");
        XLSX.writeFile(wb, fileName + `.xlsx`);
        document.body.removeChild(table);
      }
    },



    //담당자리스트
    async getHandlerList(){
      //담당자정보
      let chargePList = await this.$api("/api/handlerInfo", {})
      if(chargePList.length > 0)
      {
        this.chargePList = chargePList;
      }
    },

    //확정수지계산서호출
    async makeProfitAndLoss(plCode, sMonth){
      let fFlag = "Y"

      const width = window.innerWidth * 0.90;         // 현재 창의 너비의 90%
      const height = window.innerHeight * 1;          // 현재 창의 높이의 100%
      const left = (window.innerWidth - width) / 2;   // 가운데 정렬을 위한 왼쪽 위치 계산
      const top = (window.innerHeight - height) / 2;  // 가운데 정렬을 위한 위쪽 위치 계산

      const url = `/businessInvoice_profit_loss?sD=&sM=${sMonth}&sNt=&sAr=&sCp=&pCode=${plCode}&fFlag=${fFlag}`;
      window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
    },

    openModal(sel_dealCode){
      this.showModal = true
      this.sel_dealCode = sel_dealCode
    },

    //검색조건 초기화
    searchDefault(){
      this.searchMonth = ""
      this.chargePerson = this.isChargeListOpen ? "" : this.user.handlerId
    },

    closeModal(){
      this.showModal = false;
    },

    //그리드에서 선택된 로우정보취득
    onGridReady(params) { 
      this.gridOptions.api = params.api;    //할당을 해야 함(실서버용)
      const gridApi = params.api;

      //gridApi에 이벤트리스너 등록
      gridApi.addEventListener("selectionChanged:", this.onSelectionChanged)

      // 체크된 노드
      let selectedNodes = gridApi.getSelectedNodes();

      // 선택된 로우의 데이터를 배열로 저장
      let selectedData = selectedNodes.map(node => node.data);

      console.log("selectedData:", selectedData);
    },

    // //그리드에서 선택된 로우정보취득
    // onGridReady(params) {
    //   this.gridOptions.api = params.api;    //할당을 해야 함(실서버용)
    //   const gridApi = params.api;

    //   //gridApi에 이벤트리스너 등록
    //   gridApi.addEventListener("selectionChanged:", this.onSelectionChanged)

    //   // 체크된 노드
    //   let selectedNodes = gridApi.getSelectedNodes();

    //   // 선택된 로우의 데이터를 배열로 저장
    //   let selectedData = selectedNodes.map(node => node.data);

    //   console.log("selectedData:", selectedData);
    // },

    //선택된 그리드값 취득
    onSelectionChanged(){
      let selectedRows = this.gridOptions.api.getSelectedNodes();
      let selectedData = selectedRows.map(node => node.data);
      //console.log("selectedData:", selectedData);

      let selectedPNLfixed = []
      selectedPNLfixed = selectedData.map(row => 
      (
        {
          code: row.plCode,
          month: row.plMonth,
          handler: row.handlerNameKor
        }
      ))

      this.selectedPNLfixed = selectedPNLfixed
      //console.log("this.selectedPNLfixed:", this.selectedPNLfixed)
    },

    //클릭된 그리드의 plCode취득
    onCellClicked(event){
      let selectedRows = this.gridOptions.api.getSelectedNodes();
      let sel_rowData = selectedRows.map(node => node.data);
      //console.log("sel_rowData:",sel_rowData)
      
      let sel_plCode = sel_rowData[0].plCode
      let selectedMonth = sel_rowData[0].plMonth
      //console.log("sel_dealCode:", sel_dealCode);

      //그리드 클릭
      if(event.event.target.innerText === "파기")
      {
        //확정수지계산서 취소
        this.cxl_plReport(sel_plCode)
        //this.goToBizInvoice(sel_dealCode);
      }
      else
      {
        //상세페이지로 이동
        this.goToBizInfoDetail(sel_plCode, selectedMonth);
      }
    },

    async cxl_plReport(plCode){
      let plFix = "N"
      let plUseFlag = "N"
      let res_fixedProfitLoss = await this.$api("/api/upd_fixedProfitLoss", {param: [plFix, plUseFlag, plCode]} )
      if(res_fixedProfitLoss.affectedRows > 0)
      {
        this.$swal.fire("", `${plCode}는 파기되었습니다`, "info")
        location.reload(true)
      }
      else
      {
        this.$swal.fire("", `${plCode}의 파기에 오류가 발생했습니다. 재시도해주세요`, "info")
        return false
      }
    },

    //상세정보로 이동(새탭에서 열기)
    goToBizInfoDetail(dCode, sMonth){
      this.makeProfitAndLoss(dCode, sMonth)
      // const url = `/businessInfo_detail?dCode=${dCode}`;
      // window.open(url, '_blank');
    },

    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    // mixins에 있는 공통함수 호출샘플
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },

    //정산데이타 검색(프로시저이용)
    async searchSettleData(param){
      let searchDuration = ""
      let searchMonth = ""

      //확정수지계산서추출
      if(param === "default")
      {
        //기본값인 경우 당해월 수지계산서 리스트 호출
        let today = new Date();
        let yy = today.getFullYear().toString();
        let mm = today.getMonth()+1;
        let ym = `${yy}-${mm}`;

        searchDuration = "G"
        searchMonth = ym
      }
      else
      {
        searchDuration = this.searchDuration
        searchMonth = this.searchMonth
      }

      let settleDataInfo_tmp = await this.$api("/api/proc_searchProfitLoss_fixed", {param: [
        searchDuration, searchMonth, this.chargePerson
      ]});
      
      if(settleDataInfo_tmp.length > 0)
      {
        if (settleDataInfo_tmp.length > 0) 
        {
          this.settleDataInfo = settleDataInfo_tmp[1];

          for(let i=0; i<this.settleDataInfo.length; i++)
          {
            let sales_KRW_tot = 0
            let dPrice_curKRW_sum_n_tot = 0
            let dPrice_curJPY_sum_n_tot = 0
            let dPrice_curUSD_sum_n_tot = 0
            let dPrice_curTWD_sum_n_tot = 0
            let searchersFee_n_tot = 0
            let providePrice_n_tot = 0
            let vatPrice_n_tot = 0
            let accountRecievalbe_n_tot = 0
            let profit_n_tot = 0

            sales_KRW_tot             = this.getCurrencyFormat(this.settleDataInfo[i].sales_KRW_tot)
            dPrice_curKRW_sum_n_tot   = this.getCurrencyFormat(this.settleDataInfo[i].dPrice_curKRW_sum_n_tot)
            dPrice_curJPY_sum_n_tot   = this.getCurrencyFormat(this.settleDataInfo[i].dPrice_curJPY_sum_n_tot)
            dPrice_curUSD_sum_n_tot   = this.getCurrencyFormat(this.settleDataInfo[i].dPrice_curUSD_sum_n_tot)
            dPrice_curTWD_sum_n_tot   = this.getCurrencyFormat(this.settleDataInfo[i].dPrice_curTWD_sum_n_tot)
            searchersFee_n_tot        = this.getCurrencyFormat(this.settleDataInfo[i].searchersFee_n_tot)
            providePrice_n_tot        = this.getCurrencyFormat(this.settleDataInfo[i].providePrice_n_tot)
            vatPrice_n_tot            = this.getCurrencyFormat(this.settleDataInfo[i].vatPrice_n_tot)
            accountRecievalbe_n_tot   = this.getCurrencyFormat(this.settleDataInfo[i].accountRecievalbe_n_tot)
            profit_n_tot              = this.getCurrencyFormat(this.settleDataInfo[i].profit_n_tot)

            // settleDataInfo 배열 객체에 수지계산 지출합산결과 추가
            this.settleDataInfo[i] = {
              ...this.settleDataInfo[i],
              sales_KRW_tot,          
              dPrice_curKRW_sum_n_tot,
              dPrice_curJPY_sum_n_tot,
              dPrice_curUSD_sum_n_tot,
              dPrice_curTWD_sum_n_tot,
              searchersFee_n_tot,
              providePrice_n_tot,    
              vatPrice_n_tot,    
              accountRecievalbe_n_tot,
              profit_n_tot
            };            
          }

          this.rowData = this.settleDataInfo;
        }
        //console.log("rowData:::::::::::::::::::::::", this.rowData)
      }

      // if(this.dCode != "")
      // {
      //   this.rowData = this.settleDataInfo.filter(item => {
      //     return item.dealCode === this.dCode.trim()
      //   })
      // }
    },

  }
}
</script>

<style scoped>
.ag-header-cell-label {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.ag-theme-balham ::ng-deep .ag-header-cell .ag-header-cell-text {
  display: flex;
  align-items: center;
  justify-content: center;
}

/** 그리드 컬럼값 컨트롤 */
.red-font-bold {
  color:red;
  font-weight: bold;
}

/**Modal CSS */
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;;
  /*z-index: 1;*/
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 5px;
  border: 1px solid #888;
  max-width: 100%;
  max-height: 100%;
  border-radius: 5px;
  /*box-shadow: 0 0px 0px rgba(0, 0, 0, 0.2);*/
}
</style>